export default "/assets/images/hw-carbon.webp?a59a3e09ad0d1037d99130c305ba266d";